import { useState } from 'react'
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Field,
  Input,
  NativeSelect,
  useToast,
} from '@insightai/ui'
import { COMPANY_SIZES } from '@insightai/auth'
import { MarketingPage, Section } from './MarketingPage'

/**
 * M00-09 / M00-14.
 *
 * The resource library is content-dependent and ships as a stub. The demo request
 * form is real but marked Optional in the tracker: at V1.0 it can hand off to an
 * external scheduler. Submission is wired to a toast rather than a fake success
 * page, so nothing here claims to have sent something it did not.
 */
export function ResourcesPage() {
  const toast = useToast()
  const [submitting, setSubmitting] = useState(false)

  return (
    <MarketingPage
      title="Resources"
      lede="Methodology notes and worked examples from the research team. The library is being populated ahead of launch."
    >
      <Section heading="Coming soon">
        <ul className="flex flex-col gap-3">
          {[
            'Writing a business question that survives decomposition',
            'When secondary research is enough — and when it is not',
            'Reading a cross-tab with letter notation',
            'Why we always generate a null hypothesis',
          ].map((title) => (
            <li key={title} className="border-s-2 border-border-strong ps-4 text-body-sm text-text-secondary">
              {title}
            </li>
          ))}
        </ul>
      </Section>

      <Section id="demo" heading="Book a platform demo">
        <Card>
          <CardHeader>
            <CardTitle className="text-body">Request a walkthrough</CardTitle>
          </CardHeader>
          <CardContent>
            <form
              className="flex flex-col gap-4"
              onSubmit={(event) => {
                event.preventDefault()
                setSubmitting(true)
                // Wired to the CRM in Phase 1; deliberately not faking success.
                setTimeout(() => {
                  setSubmitting(false)
                  toast({
                    title: 'Not connected yet',
                    description:
                      'The demo form is not wired to our CRM in this build. Email hello@insightai.example and we will reply the same day.',
                    tone: 'warning',
                    duration: null,
                  })
                }, 300)
              }}
            >
              <div className="grid gap-4 sm:grid-cols-2">
                <Field label="Work email" required>
                  <Input type="email" name="email" autoComplete="email" required />
                </Field>
                <Field label="Your name" required>
                  <Input name="name" autoComplete="name" required />
                </Field>
              </div>
              <Field label="Company size">
                <NativeSelect name="companySize" defaultValue="">
                  <option value="" disabled>
                    Select…
                  </option>
                  {COMPANY_SIZES.map((size) => (
                    <option key={size.value} value={size.value}>
                      {size.label}
                    </option>
                  ))}
                </NativeSelect>
              </Field>
              <Button type="submit" loading={submitting} className="w-fit">
                Request demo
              </Button>
            </form>
          </CardContent>
        </Card>
      </Section>
    </MarketingPage>
  )
}
